









import Vue from 'vue'

// The "click to open the settings" pill shown over a hovered element of the
// preview: sections, header, footer and the cookie banner share it.
export default Vue.extend({
  name: 'PreviewTapHint',
  props: {
    text: {
      type: String,
      required: true
    }
  }
})
